import { AISearchContainer } from '@/pages/AISearch/index';
import { Box, Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';

export const GlobalSearchV1 = ({ onClose }: { onClose: () => void }) => {
  return (
    <Modal isOpen={true} onClose={onClose} size="full">
      <ModalOverlay />
      <ModalContent
        w="100%"
        h="100%"
        border="none"
        borderRadius="none"
        bg="rgba(0, 0, 0, 0.0001)"
        boxShadow="none"
        onClick={onClose}
      >
        <Box
          className="ai-search-container-wrapper"
          onClick={(e) => {
            e.stopPropagation();
            const targetClass = (e.target as HTMLElement).className || null;
            if (targetClass?.includes?.('ai-search-container-wrapper')) {
              onClose();
            }
          }}
        >
          <AISearchContainer onClose={onClose} />
        </Box>
      </ModalContent>
    </Modal>
  );
};
